<ng-container>
  <c-container [fluid]="true" class="border-bottom px-4 backgroundframe">
    <button
      [cSidebarToggle]="sidebarId"
      cHeaderToggler
      class="btn"
      toggle="visible"
      style="margin-inline-start: -14px"
      aria-label="Toggle sidebar navigation"
    >
      <svg cIcon name="cilMenu" size="lg"></svg>
    </button>
    <c-header-nav class="d-flex align-items-center w-auto ms-4">
      <p class="p-0 m-0" style="font-size: 17px">
        {{ provider.companyinfo.company.firmName }} ({{ provider.companyinfo.finyear.divId }})
      </p>
    </c-header-nav>

    <c-header-nav class="d-none d-md-flex ms-auto">
      <a cNavLink>
        <svg cIcon class="my-1" name="cilBell" size="lg"></svg>
      </a>
      <c-dropdown alignment="end" variant="nav-item">
        <button cNavLink cDropdownToggle type="button">
          <svg cIcon class="my-1" name="cilUser" size="lg"></svg>
        </button>
        <ul cDropdownMenu>
          <li>
            <button cDropdownItem (click)="onUserInfo()">
              <svg cIcon name="cilUser" class="me-2"></svg>
              User Info
            </button>
          </li>
          <li>
            <button cDropdownItem (click)="onResetPassword()">
              <svg cIcon name="cilLockLocked" class="me-2"></svg>
              Reset Password
            </button>
          </li>
        </ul>
      </c-dropdown>
    </c-header-nav>

    <c-header-nav class="ms-auto ms-md-0">
      <div class="nav-item py-1">
        <div class="vr h-100 mx-2 text-body text-opacity-75"></div>
      </div>
    </c-header-nav>

    <c-header-nav class="mx-0">
      <button class="btn btn-clear border-0" (click)="logout()">
        <svg cIcon class="ms-2" name="cilAccountLogout" style="transform: scaleX(-1)"></svg>
      </button>
    </c-header-nav>
  </c-container>

  <!-- Reset Password Modal -->
  <app-reset-password-modal
    [visible]="showResetPasswordModal"
    (visibleChange)="onModalVisibleChange($event)"
    [userId]="provider.companyinfo.userinfo?.user_id"
    (passwordReset)="onPasswordResetSubmit($event)"
  ></app-reset-password-modal>

  <app-user-info-modal
    [visible]="showUserModal"
    (visibleChange)="onUserModalVisibleChange($event)"
  ></app-user-info-modal>
</ng-container>
